module.exports = "<h5 class=\"text-white font-weight-light mb-0\">{{ this.selectedBuilding }}</h5>\r\n"